import React from 'react';

import {
  Border,
  Colors,
  Typography,
  createClasses,
  pxToRem,
  spacing,
} from '@kp/react-ui';

import { useLocaleDateFns } from '@/hooks/useLocaleDateFns';

const classes = createClasses({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: pxToRem(64),
    height: pxToRem(64),
    padding: spacing('xxs'),
    borderRadius: Border.Radius.Small,
    border: `1px solid ${Colors.Neutral.border}`,
    backgroundColor: Colors.Neutral.background,
    textAlign: 'center',
    flexShrink: 0,
  },
  day: {
    color: Colors.Selected.text,
  },
  month: {
    color: Colors.Neutral.textInactive,
  },
});

interface DateBadgeProps {
  date?: Date;
}

export const DateBadge: React.FC<DateBadgeProps> = ({ date = new Date() }) => {
  const { format } = useLocaleDateFns();

  return (
    <div className={classes.root}>
      <Typography variant="titleLarge" className={classes.day}>
        {format(date, 'd')}
      </Typography>
      <Typography variant="bodySmall" className={classes.month}>
        {format(date, 'MMM')}
      </Typography>
    </div>
  );
};
